import Form from 'mobx-react-form';
import plugins from './plugins';
import { REPORT_EMAIL_TYPES } from '../containers/settings/email-settings/constants';

const reportEmailFields = REPORT_EMAIL_TYPES.reduce((fields, type) => {
    fields[`${type.key}_subject`] = {
        label: `Subject in ${type.label} emails`,
        rules: 'string',
    };
    fields[`${type.key}_text`] = {
        label: `Text in ${type.label} emails`,
        rules: 'string',
    };
    fields[`${type.key}_textEnabled`] = {
        label: `Customize Text for ${type.label} emails`,
        rules: 'string',
    };
    fields[`mrkdwn_${type.key}_text`] = {};
    return fields;
}, {});

const fields = {
    trainingHeader: {
        label: 'Header in training emails',
        rules: 'string',
    },
    trainingFooter: {
        label: 'Footer in training emails',
        rules: 'string',
    },
    reminderTrainingHeader: {
        label: 'Header in training reminder emails',
        rules: 'string',
    },
    reminderTrainingFooter: {
        label: 'Footer in training reminder emails',
        rules: 'string',
    },
    reminderAssessmentHeader: {
        label: 'Header in assessment reminder emails',
        rules: 'string',
    },
    reminderAssessmentFooter: {
        label: 'Footer in assessment reminder emails',
        rules: 'string',
    },
    assessmentHeader: {
        label: 'Header in assessment emails',
        rules: 'string',
    },
    assessmentFooter: {
        label: 'Footer in assessment emails',
        rules: 'string',
    },
    welcomeMessage: {
        label: 'User Welcome Enrollment emails',
        rules: 'string',
    },
    training_subject: {
        label: 'Subject in training emails',
        rules: 'string|required|not_empty_trim',
    },
    reminder_training_subject: {
        label: 'Subject in training reminder emails',
        rules: 'string|required|not_empty_trim',
    },
    reminder_assessment_subject: {
        label: 'Subject in assessment reminder emails',
        rules: 'string|required|not_empty_trim',
    },
    assessment_subject: {
        label: 'Subject in assessment emails',
        rules: 'string|required|not_empty_trim',
    },
    training_greeting: {
        label: 'Greeting in training emails',
        rules: 'string',
    },
    reminder_training_greeting: {
        label: 'Greeting in training reminder emails',
        rules: 'string',
    },
    reminder_assessment_greeting: {
        label: 'Greeting in assessment reminder emails',
        rules: 'string',
    },
    assessment_greeting: {
        label: 'Greeting in assessment emails',
        rules: 'string',
    },
    mrkdwn_trainingHeader: {},
    mrkdwn_trainingFooter: {},
    mrkdwn_reminderTrainingHeader: {},
    mrkdwn_reminderTrainingFooter: {},
    mrkdwn_reminderAssessmentHeader: {},
    mrkdwn_reminderAssessmentFooter: {},
    mrkdwn_assessmentHeader: {},
    mrkdwn_assessmentFooter: {},
    mrkdwn_welcomeMessage: {},
    trainingHeaderEnabled: {
        label: 'Customize Header in training emails',
        rules: 'string',
    },
    trainingFooterEnabled: {
        label: 'Customize Footer in training emails',
        rules: 'string',
    },
    reminderTrainingHeaderEnabled: {
        label: 'Customize Header in training reminder emails',
        rules: 'string',
    },
    reminderTrainingFooterEnabled: {
        label: 'Customize Footer in training reminder emails',
        rules: 'string',
    },
    assessmentHeaderEnabled: {
        label: 'Customize Header in assessment emails',
        rules: 'string',
    },
    assessmentFooterEnabled: {
        label: 'Customize Footer in assessment emails',
        rules: 'string',
    },
    reminderAssessmentHeaderEnabled: {
        label: 'Customize Header in assessment reminder emails',
        rules: 'string',
    },
    reminderAssessmentFooterEnabled: {
        label: 'Customize Footer in assessment reminder emails',
        rules: 'string',
    },
    welcomeMessageEnabled: {
        label: 'Customize Welcome Message',
        rules: 'string',
    },
    ...reportEmailFields,
};

class EmailSettingsForm extends Form {
    constructor(setup, options) {
        super({ fields, ...setup }, { plugins, ...options });
    }
}

export default EmailSettingsForm;
